import * as React from 'react';
import { Icon, Tooltip } from '@wfp/ui'
import { iconHelpGlyph } from "@wfp/icons";

import './Tipmark.scss';


interface Props {
	className?: string;
	icon?: any;
}

export function Tipmark(props: React.PropsWithChildren<Props>) {
	return (
		<Tooltip dark trigger="hover" placement="top"
				 createRefWrapper={true}
				 content={(<div>{props.children}</div>)}>
			<Icon className="tipmark-icon"
				description=" " fill="#888"
				icon={props.icon || iconHelpGlyph}
			/>
		</Tooltip>
	);
}
